const primary = "#70578b"
export const mainTheme = {
  palette: {
    type: "light",
    primary: {
      light: "#C198ED",
      main: primary,
      dark: "#663399",
      contrastText: "#FFFFFF"
    },
    secondary: {
      main: "#EB0043",
      contrastText: "#FFFFFF"
    },
    white: {
      light: "#F5F5F5",
      main: "#ffffff",
      dark: "#DEDEDE",
      contrastText: "#333333"
    },
    black: {
      light: "#2F2F2F",
      main: "#000000"
    },
    gray: {
      light: "#BCBCBC",
      main: "#666666",
      dark: "#464646"
    },
    purple: {
      light: "#C198ED",
      main: primary,
      dark: "#663399",
      contrastText: "#FFFFFF"
    },
    red: {
      light: "#FF0033",
      main: "#E10600"
    },
    yellow: {
      main: "#FCE300"
    },
    green: {
      main: "#008330"
    },
    warning: {
      main: "rgba(252,227,0,0.12)",
      dark: "#FCE300",
      contrastText: "#464646"
    },
    success: {
      main: "rgba(0,131,48,0.12)",
      dark: "#008330",
      contrastText: "#464646"
    },
    error: {
      light: "rgba(225,6,0,0.12)",
      main: "#E10600",
      dark: "#E10600"
    }
  },
  typography: {
    fontFamily: [
      "Barlow",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"'
    ].join(",")
  },
  spacing: 4,
  overrides: {
    MuiFormControl: {
      marginDense: {
        marginTop: 0,
        marginBottom: 0
      }
    },
    MuiButton: {
      root: {
        padding: `8px 16px`
      }
    },
    MuiTypography: {
      h1: {
        fontSize: 26
      },
      h2: {
        fontSize: 22
      },
      h3: {
        fontSize: 20
      },
      h4: {
        fontSize: 16
      },
      h5: {
        fontSize: 14
      },
      h6: {
        fontSize: 12
      },
      subtitle1: {
        fontSize: 13,
        fontWeight: "bold"
      },
      subtitle2: {
        fontSize: 10,
        fontWeight: "bold"
      },
      body1: {
        fontSize: 14
      },
      body2: {
        fontSize: 14
      },
      colorTextPrimary: {
        color: "#FFFFFF"
      }
    }
  }
}
export default mainTheme
